<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  height: 286px;
  margin: 0 auto;
  padding: 8px 5px;
  color: #fff;
  text-align: center;
  overflow: hidden;
  .swiper-wrap{
    height: 286px;
  }

  .tit {
    font-size: 18px;
    margin-top: 60px;
    text-align: center;
    // line-height: 138px;
  }

  .list {
    color: #fff;
    margin-top: 20px;
    margin-left: 32px;

    .list-item {
      display: flex;
      margin-bottom: 5px;
      line-height: 2;

      .name {
        margin-right: 15px;
        font-size: 14px;
        width: 82px;
        text-align: right;
      }

      .length {
        margin-right: 10px;
        margin-top: 3px;
        width: 168px;
        height: 8px;
        background: rgba(255, 181, 43, 0.22);
        border-radius: 4px;

        .active {
          height: 100%;
          background: linear-gradient(90deg, #FCC94A, #FF8700);
        }
      }

      .num {
        font-size: 14px;
      }
    }

    .list-item:nth-child(1) .length .active {
      width: 90%;
    }

    .list-item:nth-child(2) .length .active {
      width: 70%;
    }

    .list-item:nth-child(3) .length .active {
      width: 60%;
    }
  }

  .top {
    width: 428px;
    height: 124px;
    margin-bottom: 15px;
    background: url('../../../../static/img/helpPoor/bg4.png') no-repeat;
    display: flex;

    .tit1 {
      margin-left: 34px;
    }
  }

  .bottom {
    margin-bottom: 15px;
    width: 428px;
    height: 124px;
    background: url('../../../../static/img/helpPoor/bg3.png') no-repeat;
    display: flex;
    flex-direction: row-reverse;

    .tit2 {
      margin-right: 30px;
    }
  }

  .reverse-list {
    margin-right: 30px;
    margin-left: 0;

    .reverse {
      flex-direction: row-reverse;

      .name {
        margin-right: 10px;
        text-align: left;
      }

      .num {
        margin-right: 10px;
      }

      .length {
        display: flex;
        flex-direction: row-reverse;
        background: rgba(121, 206, 47, 0.22);

        .active {
          background: linear-gradient(90deg, #c0e450, #75cd2d);
        }
      }
    }
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="table">
      <swiper :options="swiperOption" class="swiper-wrap" ref="mySwiper" v-if="listData.length!=0">
        <swiper-slide v-for="(item,index) in listData" :key="index" :class="changeClassName(index)">
          <!-- <div :class="changeClassName(index)"> -->
          <p :class="changeTitClass(index)">{{item.name}}</p>
          <div :class="changeListClass(index)">
            <div :class="changeListItemClass(index)">
              <div class="name">采购总额(元)</div>
              <div class="length">
                <div class="active"></div>
              </div>
              <div class="num">{{item.total}}</div>
            </div>
            <div :class="changeListItemClass(index)" class="list-item">
              <div class="name">采购数量</div>
              <div class="length">
                <div class="active"></div>
              </div>
              <div class="num">{{item.mount}}</div>
            </div>
            <div :class="changeListItemClass(index)">
              <div class="name">平均单价(元)</div>
              <div class="length">
                <div class="active"></div>
              </div>
              <div class="num">{{item.price}}</div>
            </div>
          </div>
          <!-- </div> -->
        </swiper-slide>
      </swiper>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from 'components/dashboard/common/boxWrap';
import '../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      name: '电商扶贫产品分析',
      listData: [
        { name: '芒果', total: 83452, mount: 3558, price: 6.232 },
        { name: '沃柑', total: 73452, mount: 2558, price: 2.232 },
        { name: '圣女果', total: 63452, mount: 4558, price: 3.232 },
        { name: '火龙果', total: 53452, mount: 6558, price: 4.232 },
        { name: '百香果', total: 43452, mount: 5558, price: 5.232 }
      ],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 170,
        // 自动播放
        // autoplay: false,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  methods: {
    changeClassName(index) {
      if (index % 2 === 0) {
        return 'top'
      } else {
        return 'bottom'
      }
    },
    changeTitClass(index) {
      if (index % 2 === 0) {
        return 'tit tit1'
      } else {
        return 'tit tit2'
      }
    },
    changeListClass(index) {
      if (index % 2 === 0) {
        return 'list'
      } else {
        return 'list reverse-list'
      }
    },
    changeListItemClass(index) {
      if (index % 2 === 0) {
        return 'list-item'
      } else {
        return 'list-item reverse'
      }
    }
  },
  mounted() {
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?55970aa4